import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, openUrl, remove } from 'kapix-components-vue3'
import ctaProgrammeSurMesurePrendreRdvComponentStoreCustom from './store.custom'

const storeName = 'ctaProgrammeSurMesurePrendreRdvComponent'
const customImplement: CustomStoreImplementationOptions = ctaProgrammeSurMesurePrendreRdvComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function ctaProgrammeSurMesurePrendreRdvComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          title: undefined as Nullable<string>,
          text: undefined as Nullable<string>,
          cta: undefined as Nullable<string>,
          ctaLink: undefined as Nullable<string>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $title (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.title,
          set: (value) => {
            this.$data.title = value
            this.$emit('update:title', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $text (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.text,
          set: (value) => {
            this.$data.text = value
            this.$emit('update:text', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $cta (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.cta,
          set: (value) => {
            this.$data.cta = value
            this.$emit('update:cta', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $ctaLink (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.ctaLink,
          set: (value) => {
            this.$data.ctaLink = value
            this.$emit('update:ctaLink', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      buttonClick () {
        openUrl(this.$ctaLink.value, '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return ctaProgrammeSurMesurePrendreRdvComponentFactory(storeId)()
}

export const ctaProgrammeSurMesurePrendreRdvComponentRaw = ctaProgrammeSurMesurePrendreRdvComponentFactory()
export const ctaProgrammeSurMesurePrendreRdvComponent = () => ctaProgrammeSurMesurePrendreRdvComponentRaw() as MergeCustomStore<typeof ctaProgrammeSurMesurePrendreRdvComponentStoreCustom.instance>
